<template>
  <helmi-group-dashboard-card
    :initializing="loadingCharts"
    class="helmi-group-dashboard-cumulative-return"
    title="Tuoton jakautuminen toimistoittain"
    subtitle="(Brutto)"
    fullscreen
    min-height="560px"
    use-theme
  >
    <h-pie-echart :data="echartsData"/>
  </helmi-group-dashboard-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'GroupDashboardYearlyPie',

  components: {
    'h-pie-echart': () => import('@/components/charts/PieChartEcharts'),
    'helmi-group-dashboard-card': () => import('@/components/groupDashboard/GroupDashboardCard'),
  },

  data: () => ({
    chartData: {
      datasets: [],
    },
    echartsData: [],
    context: null,
    fullscreen: false,
    loaded: false,
  }),

  computed: {
    ...mapState({
      selectedGroupCompanies: 'selectedGroupCompanies',
      chartYear: 'chartYear',
      monthlyProfit: 'monthlyProfit',
      loadingCharts: 'loadingCharts',
    }),
  },

  watch: {
    monthlyProfit: {
      async handler() {
        this.fillCharts();
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async fillCharts() {
      this.echartsData = this.monthlyProfit.map(result => ({
        name: result.name,
        value: +((result.data.map(item => item.profit)
          .reduce((a, b) => a + b, 0)).toFixed(2)),
      }));
    },
  },

};

</script>
